import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DISCORD_LINK"] */ "/opt/build/repo/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Typography.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
